import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.reducer';

export const selectUiState = createFeatureSelector<UiState>('ui');

export const selectTheme = createSelector(selectUiState, (s) => s.theme);
export const selectTelaVisibility = createSelector(selectUiState, (s) => s.telaVisibility);
export const selectDomainPanel = createSelector(selectUiState, (s) => s.domainPanel);
export const selectDarkVariant = createSelector(selectUiState, (s) => s.darkVariant);
export const selectPricingEnableWorkflow = createSelector(selectUiState, (s) => s.pricingEnableWorkflow);
export const selectSearchEnabled = createSelector(selectUiState, (s) => s.searchEnabled);
export const selectHeroVariant = createSelector(selectUiState, (s) => s.heroVariant);
export const selectShowEaProducts = createSelector(selectUiState, (s) => s.showEaProducts);
export const selectShowUnavailableButton = createSelector(selectUiState, (s) => s.showUnavailableButton);
export const selectRecentSearches = createSelector(selectUiState, (s) => s.recentSearches);
export const selectRecentlyViewed = createSelector(selectUiState, (s) => s.recentlyViewed);
